import React from "react";
import InputField from "../input/inputField";
import Dropdown from "../Dropdown/dropdown";
import { MultiSelectDropdown } from "../Dropdown/MultiSelectDropdown";
import { MultiOptions } from "../Dropdown/MultiDropdownOptions";
import { DropdownOptions } from "../dropdownOptions";
import { useGetClassesOptions } from "../../hooks/classHooks/class.hooks";
import { SUBJECT_TYPE_OPTIONS } from "../../Constants/options/classType.options";

interface Props {
  subjectName: string;
  onSubjectNameChange: (subjectName: string) => unknown;
  subjectType: DropdownOptions | null;
  onSubjectTypeChange: (subjectType: DropdownOptions) => unknown;
  selectedClass: DropdownOptions[];
  onClassChange: (classes: DropdownOptions[]) => unknown;
}
export const SubjectForm = ({
  subjectName,
  onSubjectNameChange,
  subjectType,
  onSubjectTypeChange,
  selectedClass,
  onClassChange,
}: Props) => {
  const { data: classOptions } = useGetClassesOptions();

  const CLASS_OPTIONS: MultiOptions[] = [
    {
      optionsTitle: "Classes",
      category: "",
      options: classOptions as DropdownOptions[],
    },
  ];

  return (
    <>
      <InputField
        value={subjectName}
        setValue={onSubjectNameChange}
        label={"Subject name"}
        placeHolder="Enter subject name"
      />

      <Dropdown
        label="Subject type"
        options={SUBJECT_TYPE_OPTIONS}
        selectedOption={subjectType}
        setSelectedOption={(option) => {
          onSubjectTypeChange(option);
          //   setSelectedSubjectTypeOption(option);
        }}
      />

      <MultiSelectDropdown
        label="Class"
        allOptions={CLASS_OPTIONS || []}
        selectedOptions={selectedClass}
        setOptions={onClassChange}
        // errorMessage={subjectErrMess}
        // validationOnClick={() => {
        //   if (!classId) {
        //     setSubjectErrMess("Select class first");
        //     return false;
        //   }
        //   return true;
        // }}
      />
    </>
  );
};
